import React, { useState, useEffect, useContext,useRef } from "react";
import moment from "moment";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import ReactToPrint from "react-to-print-advanced";
import {STATES_ART_ARTICULO} from "../States";
import { CLOSE_IMAGE } from "../Image";
import { NavLink as RRNavLink } from "react-router-dom";
import { mkConfig, generateCsv, download } from "export-to-csv";
import "./../www/style.css";
import StoreContext from "./../Store/Context";
import ClearIcon from '@mui/icons-material/Clear';
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { MDBIcon, MDBTabs, MDBTabsLink, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";
import {DATATABLE_ARTICULO, DATATABLE_BODEGAS, DATATABLE_CATEGORIAS, DATATABLE_MARCAS, DATATABLE_PROVEEDORES} from "../Datatables";
import {ComponentToPrintsBarcode} from "./../../Inventario/ComponentToPrintss";
import {ArticuloModal,DeleteModal,ImageTooltipModal,  BodegaModal, CategoriaModal,MarcaModal, ProveedorModal, ModalSeries} from "./../Modal";
import { IconButton } from "@mui/material";
import { FIND_DESC,EXPORT_CSV_ARTICULOS } from "./../Util";
import {get_cat_categoria,get_bod_bodega, get_mar_marca,get_pro_proveedor,get_art_articulo,post_art_articulo,put_art_articulo,put_art_articulo_sts,imgURLServer,get_itbms,
    get_artb_bodega_by_articulo,put_artb_sts,post_artb_bodega,put_delete_img,print_etiqueta_termico,get_compania_all,put_bod_bodega_principal,post_bod_bodega,
    put_bod_bodega_sts,put_bod_bodega,post_cat_categoria,put_cat_categoria,put_cat_categoria_sts,post_mar_marca,put_mar_marca,put_mar_marca_sts,  post_pro_proveedor,
  put_pro_proveedor,
  put_pro_proveedor_sts,
  get_series_by_articulo_all} from "../Services";
import { Container,Row, Col,NavLink } from "reactstrap";

export const Articulos = ()=> {
  const { usr_sucursal,usr_perfil,dataCompania,usr_a_costo,quitToken} = useContext(StoreContext);
  const [tabsActive, setTabsActive] = useState("tab1");
  const handleTabClick = (value) => {
    if (value === tabsActive) {
      return;
    }
    setTabsActive(value);
  };
 return <Container fluid className="font-s12px">
         <MDBTabs className="d-flex-none custom-navs">
            <Row>
              <Col xs={12} className="mt-3">
                <Row>
                  <Col xs={2} >
                    <MDBTabsLink onClick={() => handleTabClick("tab1")} active={tabsActive === "tab1"} className="padding-2porc">
                      <MDBIcon fas icon="money-bill" className="me-2" /> Artículos
                    </MDBTabsLink>
                  </Col>
                  <Col xs={2}>
                  {dataCompania.com_version==="2" &&<MDBTabsLink onClick={() => handleTabClick("tab2")} active={tabsActive === "tab2"} className="padding-2porc">
                      <MDBIcon fas icon="cash-register" className="me-2" /> Categorías
                    </MDBTabsLink>}
                   
                  </Col>
                  <Col xs={2}>
                  {dataCompania.com_version==="2" &&<MDBTabsLink onClick={() => handleTabClick("tab3")} active={tabsActive === "tab3"} className="padding-2porc">
                      <MDBIcon fas icon="cash-register" className="me-2" /> Marcas
                    </MDBTabsLink> }

                    </Col>
                  <Col xs={2}>
                  {dataCompania.com_version==="2" && <MDBTabsLink onClick={() => handleTabClick("tab4")} active={tabsActive === "tab4"} className="padding-2porc">
                      <MDBIcon fas icon="cash-register" className="me-2" /> Bodegas
                    </MDBTabsLink>}
                    
                  </Col>
                  <Col xs={2}>
                  {dataCompania.com_version==="2" &&<MDBTabsLink onClick={() => handleTabClick("tab5")} active={tabsActive === "tab5"} className="padding-2porc">
                      <MDBIcon fas icon="cash-register" className="me-2" /> Proveedores
                    </MDBTabsLink>}
                    
                  </Col>
                  <Col xs={2} className="text-center padding-2por">
                    <NavLink tag={RRNavLink} to="/user/home" className="font-w-bold   menu-l-c padding-2porc">
                      <img src={CLOSE_IMAGE} className="src-image-x" alt="..."/>
                    </NavLink>
                  </Col>
                </Row>
              </Col>
            </Row>
        </MDBTabs>
        <MDBTabsContent>
          <MDBTabsPane show={tabsActive === "tab1"}>
            {tabsActive === "tab1" &&  <Items/>}
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab2"}>
            {tabsActive === "tab2" &&  <Categorias/>}
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab3"}>
            {tabsActive === "tab3" &&  <Marcas/>}
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab4"}>
               {tabsActive === "tab4" &&  <Bodegas/>}
          </MDBTabsPane>
          <MDBTabsPane show={tabsActive === "tab5"}>
           {tabsActive === "tab5" &&  <Proveedores/>}
          </MDBTabsPane>
        </MDBTabsContent>
        
      </Container>
  function Bodegas() {
  const [loading, setLoading] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [error, setError] = useState("");
  const { usr_sucursal } = useContext(StoreContext);
  const [dataBodegas, setDataBodegas] = useState([]);
  const [dataCompania, setDataCompania] = useState([]);
  const [formBodegas, setFormBodegas] = useState({
    bod_id: "",
    bod_nombre: "",
    bod_suc:"",
    bod_ubicacion: "",
    bod_sts: "",
  });

  
  async function fetchCompania() {
    var response;
    response = await get_compania_all();
    setDataCompania(response);
  }

  const onClickUpdateBodega = () => {
    setLoading(true);
    var body = {
      bod_id: formBodegas.bod_id,
      bod_suc: formBodegas.bod_suc,
      bod_nombre: formBodegas.bod_nombre,
      bod_ubicacion: formBodegas.bod_ubicacion,
    };
    var result = put_bod_bodega(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchBodega();
      }
       
      else
        setError("ERROR "+data);
    })
  };

  const setBodegaPrincipal = (row) => {
    var body = {
      bod_id: row.bod_id,
      bod_suc:row.bod_suc
    };

    var result = put_bod_bodega_principal(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchBodega();
      else
        setError("ERROR "+data);
    })
  };
  const onClickUpdateBodega_sts = () => {
    var body = {
      bod_id: formBodegas.bod_id,
      bod_sts: 0,
    };

    var result = put_bod_bodega_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchBodega();
      else
        setError("ERROR "+data);
    })
  };

  const onClickSaveBodega = () => {
    setLoading(true)
    var body = {
      bod_suc: usr_sucursal,
      bod_nombre: formBodegas.bod_nombre,
      bod_suc:formBodegas.bod_suc,
      bod_ubicacion: formBodegas.bod_ubicacion,
    };
    if (formBodegas.bod_nombre.length > 0) {
      var result = post_bod_bodega(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false);
          fetchBodega();
        }
        
        else
          setError("ERROR "+data);
      })
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchBodega() {
    var response;
    response = await get_bod_bodega(usr_sucursal);
    setDataBodegas(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormBodegas({
      ...formBodegas,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchBodega();
    fetchCompania()
  }, []);

  const onChangeDropdown = (selectedOptions) => {
        setFormBodegas({
      ...formBodegas,
      bod_suc: selectedOptions.value,
    });
  };

  return (
    <Container fluid className="font-s12px">
      {basicModal && (
        <BodegaModal
          props={formBodegas}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveBodega}
          toggleSaveEdit={onClickUpdateBodega}
          onChange={onChange}
          error={error}
          loading={loading}
          dataCompania={dataCompania}
          onChangeDropdown={onChangeDropdown}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formBodegas.bod_nombre}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateBodega_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_BODEGAS dataBodegas={dataBodegas} setBasicModalDelete={setBasicModalDelete} setFormBodegas={setFormBodegas} 
        setBasicModal={setBasicModal} setBasicModalEdit={setBasicModalEdit} setError={setError} fetchBodega={fetchBodega} setBodegaPrincipal={setBodegaPrincipal}/>
        </Col>
      </Row>
    </Container>
  );
}
function Categorias() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoadingCa, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataCategorias, setDataCategorias] = useState([]);
  const [formCategorias, setFormCategorias] = useState({
    cat_id: "",
    cat_descripcion: "",
    cat_sts: "",
  });

  const onClickUpdateCategorias = () => {
    setLoading(true)
    var body = {
      cat_id: formCategorias.cat_id,
      cat_descripcion: formCategorias.cat_descripcion,
    };

    var result = put_cat_categoria(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false);
        fetchCategoria();
      }
      
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateCategorias_sts = () => {
    var body = {
      cat_id: formCategorias.cat_id,
      cat_sts: 0,
    };

    var result = put_cat_categoria_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchCategoria();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveCategorias = () => {
    setLoading(true)
    var body = {
      cat_descripcion: formCategorias.cat_descripcion,
    };
    if (formCategorias.cat_descripcion.length > 0) {
      var result = post_cat_categoria(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false)
          fetchCategoria();
        }
          
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchCategoria() {
    setLoading(true);
    var response;
    response = await get_cat_categoria();
    setDataCategorias(response);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setBasicModal(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormCategorias({
      ...formCategorias,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchCategoria();
  }, []);
  return (
    <>
      {basicModal && (
        <CategoriaModal
          props={formCategorias}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveCategorias}
          toggleSaveEdit={onClickUpdateCategorias}
          onChange={onChange}
          error={error}
          loading={isLoadingCa}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formCategorias.cat_descripcion}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateCategorias_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_CATEGORIAS
        dataCategorias={dataCategorias} 
        setBasicModalDelete={setBasicModalDelete} 
        setFormCategorias={setFormCategorias} 
        setBasicModal={setBasicModal} setBasicModalEdit={setBasicModalEdit}
        setError={setError} fetchCategoria={fetchCategoria}isLoadingCa={isLoadingCa}
        />
        </Col>
      </Row>
    </>
  );
}
function Marcas() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoadingM, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataMarcas, setDataMarcas] = useState([]);
  const [formMarcas, setFormMarcas] = useState({
    mar_id: "",
    mar_descripcion: "",
    mar_sts: "",
  });

  const onClickUpdateMarcas = () => {
    setLoading(true)
    var body = {
      mar_id: formMarcas.mar_id,
      mar_descripcion: formMarcas.mar_descripcion,
    };

    var result = put_mar_marca(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchMarcas();
      }
       
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateMarcas_sts = () => {
    var body = {
      mar_id: formMarcas.mar_id,
      mar_sts: 0,
    };

    put_mar_marca_sts(body);
    var result = put_mar_marca_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchMarcas();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveMarcas = () => {
    setLoading(true)
    var body = {
      mar_descripcion: formMarcas.mar_descripcion,
    };
    if (formMarcas.mar_descripcion.length > 0) {
      var result = post_mar_marca(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false)
          fetchMarcas();
        }
        
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchMarcas() {
    setLoading(true);
    var response;
    response = await get_mar_marca();
    setDataMarcas(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormMarcas({
      ...formMarcas,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchMarcas();
  }, []);

  return (
    <>
      {basicModal && (
        <MarcaModal
          props={formMarcas}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveMarcas}
          toggleSaveEdit={onClickUpdateMarcas}
          onChange={onChange}
          error={error}
          loading={isLoadingM}
        />
      )}
            {basicModalDelete && (
        <DeleteModal
          props={formMarcas.mar_descripcion}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateMarcas_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_MARCAS dataMarcas ={dataMarcas} 
        setBasicModalDelete={setBasicModalDelete}
        setFormMarcas={setFormMarcas}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchMarcas={fetchMarcas}
        isLoadingM={isLoadingM} />
        </Col>
      </Row>
    </>
  );
}
function Items() {
   const [srcImage, setSrcImage] = useState("");
  const [ImgName, setImgName] = useState("");
  var componentRef = useRef();
  const [loading, setLoading] = useState(false);
  const [printToolti, setPrintTooltip] = useState(false);
  const [basicModalImageTooltip, setModalImageTooltip] = useState(false);
  const [basicModalSeries, setModalSeries] = useState(false);
  
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [images, setImages] = React.useState([]);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [dataArticulos, setDataArticulos] = useState([]);
  const [error, setError] = useState("");
  const [dataCategorias, setDataCategorias] = useState([]);
  const [dataBodegas, setDataBodegas] = useState([]);
  const [dataMarca, setDataMarca] = useState([]);
  const [dataSeries, setDataSeries] = useState([]);
  const [dataItbms, setDataItbms] = useState([]);
  const [dataProveedor, setDataProveedor] = useState([]);
  const [dataArticuloBodega, setDataArticuloBodega] = useState([]);
  const [formArticulos, setFormArticulos] = useState(STATES_ART_ARTICULO("formArticulos"));
  const [formDropDown, setFormDropDown] = useState(STATES_ART_ARTICULO("formDropDown"));

  const handleExportCsv = () => {
    EXPORT_CSV_ARTICULOS({dataArticulos})
  };

  const onChangeImage = (imageList) => {
    setFormArticulos({
      ...formArticulos,
      art_imgdataurl: imageList[0]===undefined?"":imageList[0].data_url,
      art_imgType: imageList[0]===undefined?"":imageList[0].file.type,
    });
    setImages(imageList);
  };
  const onClickUpdateArticulos = () => {
    setLoading(true)
    var body = {
      art_id: formArticulos.art_id,
      art_upc: formArticulos.art_upc.replace(/ /g, ""),
      art_categoria:formDropDown.cat_id.length > 0 ? formDropDown.cat_id : formArticulos.art_categoria,
      art_proveedor:formDropDown.prov_id.length > 0 ? formDropDown.prov_id : formArticulos.art_proveedor,
      art_marca: formDropDown.mar_id.length > 0 ? formDropDown.mar_id : formArticulos.art_marca,
      art_descripcion: formArticulos.art_descripcion,
      art_serie: formArticulos.art_serie.replace(/ /g, ""),
      art_costo: formArticulos.art_costo,
      art_precio: formArticulos.art_precio,
      art_precio2: formArticulos.art_precio2,
      art_precio3: formArticulos.art_precio3,
      art_referencia: formArticulos.art_referencia,
      art_linea_roja: formArticulos.art_linea_roja,
      art_img: formArticulos.art_imgdataurl !== undefined ? "1" : "0",
      art_itbm_venta: formDropDown.itbm_porc_v,
      art_itbm_cod_v: formDropDown.itbm_cod_venta,
      art_itbm_compra: formDropDown.itbm_porc_c,
      art_itbm_cod_c: formDropDown.itbm_cod_compra,
      art_imgdataurl: formArticulos.art_imgdataurl,
      art_sucursal: usr_sucursal,
      art_imgType: formArticulos.art_imgType !== undefined ? formArticulos.art_imgType : "none",
      art_imgURLServer: imgURLServer,
      art_imgName:formArticulos.art_imgdataurl !== undefined? moment(new Date()).format("YYYYMMDDHHmmss"): formArticulos.art_imgName,
      art_restaurante:formArticulos.art_restaurante,
        art_servicio:formArticulos.art_servicio === undefined?"0":formArticulos.art_servicio,
      art_catalogo:formArticulos.art_catalogo === undefined?"0":formArticulos.art_catalogo,
    };
    if(dataCompania.com_version==="1"){
      var result = put_art_articulo(body);
          result.then((data) => {
            setError("");
            if(data===true){
              setTimeout(() => {
                //  window.location.reload();
                fetchArticulos();
                setLoading(false)
              }, 1500);

            }
            else
              setError("ERROR "+data);
          });
    }
    else{
    if (formArticulos.art_upc.length > 0 &&
      formDropDown.cat_id.length > 0 &&
      formDropDown.prov_id.length > 0 &&
      formDropDown.mar_id.length > 0 &&
      formArticulos.art_descripcion.length > 0 &&
      formArticulos.art_precio.length > 0 &&
      formDropDown.itbm_cod_compra.length > 0 &&
      formDropDown.itbm_cod_venta.length > 0) {
      if (FIND_DESC(dataArticulos, formArticulos.art_upc, formArticulos.art_id)) {
        setError("Error: CODIGO ya esta registrado");
      } else {
          var result = put_art_articulo(body);
          result.then((data) => {
            setError("");
            if(data===true)
            {
              setTimeout(() => {
                // window.location.reload();
                fetchArticulos();
                setLoading(false)
                
              }, 1500);
            }
              
            else
              setError("ERROR "+data);
          });
      }
    } else {
      setError("Campos importantes estan vacios");
    }
    }

  };

  const onClickUpdateArticulo_sts = () => {
    var body = {
      art_id: formArticulos.art_id,
      art_sts: 0,
    };
    var result = put_art_articulo_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchArticulos();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveArticulos = () => {
    setLoading(true)
    var body = {
      art_upc: formArticulos.art_upc.replace(/ /g, ""),
      art_categoria: formDropDown.cat_id.length>0?formDropDown.cat_id:"1",
      art_proveedor: formDropDown.prov_id.length>0?formDropDown.prov_id:"1",
      art_marca: formDropDown.mar_id.length>0?formDropDown.mar_id:"1",
      art_descripcion: formArticulos.art_descripcion,
      art_sucursal: usr_sucursal,
      art_serie: formArticulos.art_serie.replace(/ /g, ""),
      art_costo: formArticulos.art_costo,
      art_precio: formArticulos.art_precio,
      art_precio2: formArticulos.art_precio2,
      art_precio3: formArticulos.art_precio3,
      art_referencia: formArticulos.art_referencia,
      art_linea_roja: formArticulos.art_linea_roja,
      art_img: formArticulos.art_imgdataurl.length > 0 ? "1" : "0",
      art_itbm_venta: formDropDown.itbm_porc_v,
      art_itbm_cod_v: formDropDown.itbm_cod_venta,
      art_itbm_compra: formDropDown.itbm_porc_c,
      art_itbm_cod_c: formDropDown.itbm_cod_compra,
      art_imgdataurl: formArticulos.art_imgdataurl,
      art_imgType: formArticulos.art_imgType !== "" ? formArticulos.art_imgType : "none",
      art_imgURLServer: imgURLServer,
      inv_id:formArticulos.inv_id,
      inv_qty:formArticulos.inv_qty,
      art_imgName:formArticulos.art_imgdataurl !== undefined? moment(new Date()).format("YYYYMMDDHHmmss") : formArticulos.art_imgName,
      data_art_bodega: dataArticuloBodega,
      art_restaurante:formArticulos.art_restaurante,
      art_servicio:formArticulos.art_servicio === undefined?"0":formArticulos.art_servicio,
      art_catalogo:formArticulos.art_catalogo === undefined?"0":formArticulos.art_catalogo,
    };

    if(dataCompania.com_version==="1"){
      var result = post_art_articulo(body);
          result.then((data) => {
            setError("");
            if(data===true){
              setTimeout(() => {
                //  window.location.reload();
                fetchArticulos();
                setLoading(false)
              }, 1500);

            }
            else
              setError("ERROR "+data);
          });
    }
    else{
    if (
      formArticulos.art_upc.length > 0 &&
      formDropDown.cat_id.length > 0 &&
      formDropDown.prov_id.length > 0 &&
      formDropDown.mar_id.length > 0 &&
      formArticulos.art_descripcion.length > 0 &&
      formArticulos.art_precio.length > 0 &&
      formDropDown.itbm_cod_compra.length > 0 &&
      formDropDown.itbm_cod_venta.length > 0
    ) {
      if (FIND_DESC(dataArticulos, formArticulos.art_upc, null)) {
        setError("Error: CODIGO ya esta registrado");
      } else {
          var result = post_art_articulo(body);
          result.then((data) => {
            setError("");
            if(data===true){
              setTimeout(() => {
                //  window.location.reload();
                fetchArticulos();
                setLoading(false)
              }, 1500);

            }
            else
              setError("ERROR "+data);
          });
      }
    } else {
      setError("Campos importantes estan vacios");
      setLoading(false);
    }
    }

  };

  async function fetchArticulos() {
    var response = await get_art_articulo({usr_sucursal});
    setDataArticulos(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setError("");
  }

  async function fetchCategorias() {
    var response = await get_cat_categoria();
    setDataCategorias(response);
  }

  async function fetchBodegas() {
    var response = await get_bod_bodega();
    setDataBodegas(response);
  }

  async function fetchMarcas() {
    var response = await get_mar_marca();
    setDataMarca(response);
  }

  async function fetchItbms() {
    var response = await get_itbms();
    setDataItbms(response);
  }

  async function fetchProveedor() {
    var response = await get_pro_proveedor();
    setDataProveedor(response);
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormArticulos({
      ...formArticulos,
      [name]: value,
    });
    setError("");
    setLoading(false);
  }

  useEffect(() => {
    fetchArticulos();
    if(dataCompania.count ==="0"){
      quitToken()
    }
  }, []);

  var ObjMarca = [];
  var ObjCategoria = [];
  var ObjProveedor = [];
  var ObjBodega = [];
  var ObjItbms_venta = [];
  var ObjItbms_compra = [];
  dataMarca.map((marca) => {
    ObjMarca.push({
      value: marca.mar_id,
      label: marca.mar_descripcion,
      objName: "Marca",
    });
    return marca;
  });
  dataCategorias.map((categorias) => {
    ObjCategoria.push({
      value: categorias.cat_id,
      label: categorias.cat_descripcion,
      objName: "Categoria",
    });
     return categorias;
  });
  dataProveedor.map((proveedor) => {
    ObjProveedor.push({
      value: proveedor.prov_id,
      label: proveedor.prov_nombre,
      objName: "Proveedor",
    });
    return proveedor;
  });
  dataBodegas.map((bodega) => {
    ObjBodega.push({
      value: bodega.bod_id,
      label: bodega.bod_nombre,
      objName: "Bodega",
    });
    return bodega;
  });
  dataItbms.map((itbms) => {
    ObjItbms_venta.push({
      value: itbms.itbm_cod_number,
      label: itbms.itbm_descripcion,
      itbm_porc_v: itbms.itbm_porc,
      objName: "itbms_venta",
    });
    ObjItbms_compra.push({
      value: itbms.itbm_cod_number,
      label: itbms.itbm_descripcion,
      itbm_porc_c: itbms.itbm_porc,
      objName: "itbms_compra",
    });
    return itbms;
  });
  var propsDropdown = {
    categorias: ObjCategoria,
    marcas: ObjMarca,
    bodegas: ObjBodega,
    proveedor: ObjProveedor,
    itbms_venta: ObjItbms_venta,
    itbms_compra: ObjItbms_compra,
  };
  const onClickGenerateCodigo = () => {
    setFormArticulos({
      ...formArticulos,
      art_upc:moment(new Date()).format("MMDDHHmmss")
    });
  };

  const removeImage = (data) => {
    if (basicModalEdit) {
      var body = {
        art_id: data,
      };

      var result = put_delete_img(body);
      result.then((data) => {
        setError("");
        if(data===true)
          setFormArticulos({
            ...formArticulos,
            art_imgdataurl: "",
            art_imgType:"",
            art_imgName:"",
            art_img:""
          });
        else
          setError("ERROR "+data);
      });

    }
  };

  async function openModalSeries(data) {
    setModalSeries(true)
        setFormArticulos({data});
    var response = await get_series_by_articulo_all({art_id:data.art_id,sucursal:usr_sucursal})
    setDataSeries(response);

  }
  const onRemoveBodega = (data) => {
    if (basicModalEdit) {
      var body = {
        artb_id: data.artb_id,
      };
      put_artb_sts(body);
      var result = put_artb_sts(body);
      result.then((data) => {
        setError("");
        if(data!==true)
          setError("ERROR "+data);
      });
    } else {
      var value = dataArticuloBodega.filter((values, i) => {
        if (values.artb_bodega !== data.artb_bodega) return data
        else return null;
      });
      setDataArticuloBodega(value);
    }
  };

  const openModalArticulos = () => {
    fetchCategorias();
    fetchBodegas();
    fetchMarcas();
    fetchProveedor();
    fetchItbms();
    setBasicModal(true);
    setFormArticulos(STATES_ART_ARTICULO("formArticulos"))
  }
  const onChangeDropdown = (selectedOptions) => {
    setError("");
    if (selectedOptions.objName === "Bodega") {
      var value = false;
      dataArticuloBodega.filter((values, i) => {
        if (values.artb_bodega === selectedOptions.value) {
          value = true;
          return true;
        }
        else{
           return null;
        }
      });

      if (!value) {
        if (basicModalEdit) {
          var result = post_artb_bodega({
            artb_articulo: formArticulos.art_id,
            artb_bodega: selectedOptions.value,
            artb_code:formArticulos.art_id+"_"+selectedOptions.value
          });;
          result.then((data) => {
            setError("");
            if(data!==true)
              setError("ERROR "+data);
          });
        } else {
          setDataArticuloBodega([
            ...dataArticuloBodega,
            ...[
              {
                artb_bodega: selectedOptions.value,
                bod_nombre: selectedOptions.label,
              },
            ],
          ]);
        }
      }
    }
    if (selectedOptions.objName === "Proveedor") {
      setFormDropDown({
        ...formDropDown,
        prov_id: selectedOptions.value,
        prov_nombre: selectedOptions.label,
      });
    }
    if (selectedOptions.objName === "Categoria") {
      setFormDropDown({
        ...formDropDown,
        cat_id: selectedOptions.value,
        cat_descripcion: selectedOptions.label,
      });
    }
    if (selectedOptions.objName === "Marca") {
      setFormDropDown({
        ...formDropDown,
        mar_id: selectedOptions.value,
        mar_descripcion: selectedOptions.label,
      });
    }
    if (selectedOptions.objName === "itbms_venta") {
      setFormDropDown({
        ...formDropDown,
        itbm_cod_venta: selectedOptions.value,
        itbm_porc_v: selectedOptions.itbm_porc_v,
        itbm_descripcion_venta: selectedOptions.label,
      });
    }
    if (selectedOptions.objName === "itbms_compra") {
      setFormDropDown({
        ...formDropDown,
        itbm_cod_compra: selectedOptions.value,
        itbm_porc_c: selectedOptions.itbm_porc_c,
        itbm_descripcion_compra: selectedOptions.label,
      });
    }
    setLoading(false);
  };
  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setFormArticulos({
      ...formArticulos,
      [name]:value==="0"?"1":"0"
  })
  };

  return (
    <>
      {basicModal && (
        <ArticuloModal
          props={formArticulos}
          propsArtBodega={dataArticuloBodega}
          propsDropdown={propsDropdown}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveArticulos}
          toggleSaveEdit={onClickUpdateArticulos}
          onChange={onChange}
          onChangeDropdown={onChangeDropdown}
          onChangeImage={onChangeImage}
          images={images}
          error={error}
          onRemoveBodega={onRemoveBodega}
          removeImage={removeImage}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          loading={loading}
          onClickGenerateCodigo={onClickGenerateCodigo}
          usr_a_costo={usr_a_costo}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formArticulos.art_descripcion}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateArticulo_sts}
          text={"Eliminar este registro?"}
          error={""}
        />
      )}
      {basicModalImageTooltip && (
          <ImageTooltipModal
            props={formArticulos}
            isOpen={basicModalImageTooltip}
            toggle={setModalImageTooltip}
            srcImage ={srcImage}
            ImgName ={ImgName}
          />
      )}
     {basicModalSeries && (
          <ModalSeries
            props={dataSeries}
            formArticulos ={formArticulos}
            isOpen={basicModalSeries}
            toggle={setModalSeries}
          />
      )}
      {(printToolti && !basicModal) && (<Row className="barcode-box2">
          <Col  xs={3}>
            <IconButton onClick={() => {setPrintTooltip(false)}}>
              <ClearIcon />
            </IconButton>
          </Col>
          <Col xs={9} className="d-flex mb-5">
            <ComponentToPrintsBarcode
              ref={el => (componentRef = el)}
              formArticuloss={formArticulos}/>
            <ReactToPrint
              trigger={() => <div className="d-flex"><button className="btn-print"><IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button> </div> }
              content={() => componentRef}/>
                <button className="btn-print" onClick={() => {print_etiqueta_termico({formArticulos})}} ><IconButton className="float-right-btn"><ReceiptIcon /></IconButton></button>
          </Col>
        </Row>)}
            <Row className="mb-2 text-center mt-5">
              <Col className="modal-add-inventario datatable-factura css_datatable1"  xs={12}>
                <DATATABLE_ARTICULO
                usr_perfil={usr_perfil}
                dataArticulos ={dataArticulos} setBasicModalDelete  ={setBasicModalDelete} setBasicModalEdit  ={setBasicModalEdit} setBasicModal  ={openModalArticulos}setFormArticulos  ={setFormArticulos}
                setImages ={setImages} fetchArticulos ={fetchArticulos} setFormDropDown ={setFormDropDown} 
                setDataArticuloBodega={setDataArticuloBodega} setError={setError} setSrcImage={setSrcImage} setModalImageTooltip={setModalImageTooltip} 
                setImgName={setImgName} setPrintTooltip={setPrintTooltip} handleExportData={handleExportCsv}
                usr_a_costo={usr_a_costo}
                openModalSeries={openModalSeries}
                />
              </Col>
            </Row>
     
    </>
  );

}
function Proveedores() {
  const csvConfigProveedor = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
    filename:
      "base_de_datos_proveedores" + moment(new Date()).format("_YYYY_MM_DD") + ".csv",
  });

  const handleExportDataProve = () => {
    var prov = dataProveedores.map((data, i) => {
      return {
        ID: data.prov_id,
        Nombre: data.prov_nombre,
        Direccion: data.prov_direccion,
        Telefono: data.prov_telefono,
        RUC: data.prov_ruc.length > 0 ? data.prov_ruc + " DV " + data.prov_dv : "",
        EMAIL: data.prov_email,
      };
    });

    const csv = generateCsv(csvConfigProveedor)(prov);
    download(csvConfigProveedor)(csv);
  };
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoadingP, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataProveedores, setDataProveedores] = useState([]);
  const [formProveedores, setFormProveedores] = useState({
    prov_id: "",
    prov_suc: "",
    prov_nombre: "",
    prov_direccion: "",
    prov_telefono: "",
    prov_ruc: "",
    prov_dv: "",
    prov_sts: "",
    prov_email: "",
  });

  const onClickUpdateProveedores = () => {
    setLoading(true)
    var body = {
      prov_id: formProveedores.prov_id,
      prov_nombre: formProveedores.prov_nombre,
      prov_direccion: formProveedores.prov_direccion,
      prov_telefono: formProveedores.prov_telefono,
      prov_ruc: formProveedores.prov_ruc,
      prov_dv: formProveedores.prov_dv,
      prov_email: formProveedores.prov_email,
    };

      if (formProveedores.prov_nombre.length > 0) {
        if (
          FIND_DESC(dataProveedores, formProveedores.prov_ruc, formProveedores.prov_id)
        ) {
          setError("Error: Ruc ya esta registrado");
        } else {
          var result = put_pro_proveedor(body);
          result.then((data) => {
            setError("");
            if(data===true){
              fetchProveedores();
              setLoading(false)
            }
            else
              setError("ERROR "+data);
          });
        }
      } else {
        setError("Campos importantes estan vacios");
      }

  };

  const onClickUpdateProveedor_sts = () => {
    var body = {
      prov_id: formProveedores.prov_id,
      prov_sts: 0,
    };
    var result = put_pro_proveedor_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchProveedores();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveProveedor = () => {
    setLoading(true)
    var body = {
      prov_nombre: formProveedores.prov_nombre,
      prov_direccion: formProveedores.prov_direccion,
      prov_telefono: formProveedores.prov_telefono,
      prov_ruc: formProveedores.prov_ruc,
      prov_dv: formProveedores.prov_dv,
      prov_email: formProveedores.prov_email,
    };
      if (formProveedores.prov_nombre.length > 0) {
        if (FIND_DESC(dataProveedores, formProveedores.prov_ruc, null)) {
          setError("Error: Ruc ya esta registrado");
        } else {
          var result = post_pro_proveedor(body);
          result.then((data) => {
            setError("");
            if(data===true){
              setLoading(false);
              fetchProveedores();
            }
           
            else
              setError("ERROR "+data);
          });
        }
      } else {
        setError("Campos importantes estan vacios");
      }

  };

  async function fetchProveedores() {
    setLoading(true);
    var response;
    response = await get_pro_proveedor();
    setDataProveedores(response);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setBasicModal(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormProveedores({
      ...formProveedores,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchProveedores();
  }, []);

  return (
    <>
      {basicModal && (
        <ProveedorModal
          props={formProveedores}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveProveedor}
          toggleSaveEdit={onClickUpdateProveedores}
          onChange={onChange}
          error={error}
          loading={isLoadingP}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={
            formProveedores.prov_nombre +
            " " +
            formProveedores.prov_ruc +
            " " +
            formProveedores.prov_dv
          }
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateProveedor_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura">
          <DATATABLE_PROVEEDORES
            dataProveedores={dataProveedores}
            setBasicModalDelete={setBasicModalDelete}
            handleExportData={handleExportDataProve}
            setFormProveedores={setFormProveedores}
            setBasicModal={setBasicModal}
            setBasicModalEdit={setBasicModalEdit}
            setError={setError}
            fetchProveedores={fetchProveedores}
            isLoadingP={isLoadingP}
          />
        </Col>
      </Row>
    </>
  );
}
}